import React, { Component } from "react";
import SkeletonCard from "./SkeletonCard";

export default class SkeletonCardsList extends Component {
  render() {
    let cards = [];
    let count = this.props.count;

    for (let i = 0; i < count; i++) {
      cards.push(<SkeletonCard key={i} {...this.props} />);
    }

    return <>{cards}</>;
  }
}
